import { ScrollView } from '@play-co/timestep-core/ui';

/** Scroll view that prevents the Dream Drift map from leaving its content edges. */
export default class DreamDriftMapScrollView extends ScrollView {
  /**
   * Position the viewport immediately while synchronizing internal scroll state.
   *
   * @param x Requested horizontal scroll offset.
   * @param y Requested vertical scroll offset.
   * @returns Nothing.
   */
  public scrollToImmediate(x: number, y: number): void {
    // Convert semantic scroll offsets into the content view's coordinates.
    this.setOffset(-x, -y);
  }

  /**
   * Clamp every requested offset to the current scroll bounds.
   *
   * @param x Requested horizontal scroll offset.
   * @param y Requested vertical scroll offset.
   * @returns Nothing.
   */
  protected override _setOffset(x: number, y: number): void {
    // Read the bounds calculated from the map content and viewport.
    const bounds = this.getStyleBounds();

    // Stop both axes at their nearest valid edge before applying the offset.
    const clampedX = Math.max(bounds.minX, Math.min(bounds.maxX, x));
    const clampedY = Math.max(bounds.minY, Math.min(bounds.maxY, y));

    // Apply only the bounded offset so drag momentum cannot overscroll.
    super._setOffset(clampedX, clampedY);
  }
}
